<template>
  <div class="home">
    <template>
      <b-container class="container-rda sidebar">
        <b-row class="height">
          <sidebar-coordination />
          <b-col class="content">
            <b-row>
              <b-col>
                <Breadcrumb :breadcrumb="breadcrumb" />
              </b-col>
            </b-row>
            <b-row class="mb-5">
              <b-col>
                <h2 class="purple bold">Registrar mensalidade escolar</h2>
              </b-col>
              <b-col class="text-right"> </b-col>
            </b-row>

            <div
              class="price-card mb-5"
              v-for="(price, index) in prices"
              :key="index"
            >
              <b-row>
                <b-col md="3">
                  <StandardInput
                    v-model="price.calendar_id"
                    type="text"
                    name="designation"
                    label="Calendário"
                    :disabled="true"
                  />
                </b-col>
                <b-col md="3">
                  <b-form-group class="required">
                    <label :for="`cycle-${index}`">Ciclo</label>
                    <multiselect
                      :id="`cycle-${index}`"
                      :value="getCycleOption(price.cycle_id)"
                      :options="cycles"
                      :multiple="false"
                      :allow-empty="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Selecione"
                      class="required"
                      label="designation"
                      track-by="id"
                      selectLabel=""
                      selectedLabel=""
                      deselectLabel=""
                      @select="setPriceCycle(price, $event)"
                    >
                      <span slot="noResult">Nada encontrado</span>
                    </multiselect>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <StandardInput
                    v-model="price.cycle_name"
                    type="text"
                    name="designation"
                    label="Nome do ciclo"
                    placeholder="Fundamental 1° Ciclo"
                  />
                </b-col>
                <b-col md="3">
                  <StandardInput
                    v-model="price.cycle_description"
                    type="text"
                    name="designation"
                    label="Descrição do ciclo"
                    placeholder="1º, 2º e 3º anos"
                  />
                </b-col>
              </b-row>

              <b-row class="mt-4">
                <b-col md="3">
                  <StandardInput
                    v-model.number="price.sort_order"
                    type="number"
                    name="sort_order"
                    label="Ordem de exibição"
                    placeholder="1"
                    :min="1"
                  />
                </b-col>
                <b-col md="3">
                  <label>Valor da mensalidade</label>
                  <CurrencyInput
                    :value="price.instalment_price"
                    @input="updateInstalmentPrice($event, index)"
                  />
                </b-col>
                <b-col md="3">
                  <label>Valor da anuidade</label>
                  <CurrencyInput
                    :value="price.annuity_price"
                    :disabled="true"
                  />
                </b-col>
                <b-col md="3">
                  <label>Taxa de material</label>
                  <CurrencyInput v-model="price.material_fee" />
                </b-col>
              </b-row>

              <b-row v-if="prices.length > 1 && index > 0" class="mt-4">
                <b-col class="text-right">
                  <b-button @click="removeRow(index)" id="purple-button">
                    Deletar
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <b-row>
              <div class="w-100 mt-5"></div>
              <b-col md="4">
                <b-button
                  class="large blue outline"
                  :to="{
                    name: 'mensalidade-escolar',
                  }"
                  >Voltar</b-button
                >
              </b-col>
              <b-col md="3">
                <b-button @click="addLine" class="large blue"
                  >Adicionar linha</b-button
                >
              </b-col>
              <b-col md="4">
                <b-button
                  @click="savePrices"
                  :class="`large blue ${isValid ? '' : 'disabled'}`"
                  >Salvar</b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </div>
</template>

<script>
import StandardInput from "@/components/inputs/StandardInput.vue";
import CurrencyInput from "@/components/inputs/CurrencyInput.vue";
import cyclesService from "@/services/cycles.service";
import httpRda from "../../../http-rda";

export default {
  name: "nova-turma",
  components: {
    StandardInput,
    CurrencyInput,
  },
  data() {
    return {
      price: {
        cycle_id: null,
        cycle_name: "",
        cycle_description: "",
        instalment_price: 0,
        annuity_price: 0,
        material_fee: null,
        calendar_id: "",
        sort_order: 1,
      },
      prices: [],
      calendars: [],
      cycles: [],
      selectedCalendar: this.$route.query.calendar,
      isValid: false,
      breadcrumb: [
        {
          text: "Alterações internas",
        },
        {
          text: "Mensalidade escolar",
        },
        {
          text: "Registrar mensalidade escolar",
        },
      ],
    };
  },

  watch: {
    prices: {
      handler(values) {
        this.isValid = this.pricesValidation(values);
      },
      deep: true,
    },
  },

  methods: {
    removeRow(index) {
      this.prices.splice(index, 1);
    },

    updateInstalmentPrice(value, index) {
      this.prices[index].instalment_price = value;

      if (value && value > 0) {
        this.prices[index].annuity_price = Math.round(value * 12);
      } else {
        this.prices[index].annuity_price = 0;
      }
    },

    pricesValidation(prices) {
      const answers = [];
      prices.forEach((price) => {
        let logicResult = null;
        logicResult =
          Number.isInteger(price.cycle_id) &&
          price.cycle_name !== "" &&
          price.cycle_description !== "" &&
          price.instalment_price > 0 &&
          price.annuity_price > 0 &&
          price.calendar_id !== "" &&
          price.sort_order > 0;

        answers.push(logicResult);
      });

      return answers.every((answer) => answer === true);
    },

    async getCalendars() {
      this.calendars = await httpRda
        .get("/calendars")
        .then((resp) => resp.data.calendars);

      this.calendars = this.calendars.map((calendar) => {
        return {
          id: calendar.id,
          name: calendar.designation,
        };
      });

      this.setCalendar(this.calendars);
    },

    async getCycles() {
      const response = await cyclesService.index();
      this.cycles = response.data.cycles;
    },

    getCycleOption(cycleId) {
      return this.cycles.find((cycle) => Number(cycle.id) === Number(cycleId));
    },

    setPriceCycle(price, cycle) {
      price.cycle_id = Number(cycle.id);
    },

    addLine() {
      const newLine = {
        cycle_id: null,
        cycle_name: "",
        cycle_description: "",
        instalment_price: 0,
        annuity_price: 0,
        material_fee: null,
        sort_order: this.prices.length + 1,
        calendar_id:
          this.selectedCalendar && this.selectedCalendar.name
            ? this.selectedCalendar.name
            : "",
      };

      this.prices.push(newLine);
    },

    setCalendar(calendars) {
      this.selectedCalendar = calendars.find(
        (calendar) => +calendar.id === +this.selectedCalendar
      );

      this.price.calendar_id = this.selectedCalendar.name;
    },

    async savePrices() {
      const isValid = this.prices.every((price) => {
        return (
          Number.isInteger(price.cycle_id) &&
          price.cycle_name &&
          price.cycle_description &&
          price.instalment_price > 0 &&
          price.annuity_price > 0 &&
          price.calendar_id &&
          price.sort_order > 0
        );
      });

      if (!isValid) {
        alert("Preencha todos os campos");
        return;
      }

      const payload = this.prices.map((price) => {
        return {
          ...price,
          sort_order: price.sort_order,
          instalment_price: price.instalment_price,
          annuity_price: price.annuity_price,
          material_fee: price.material_fee || null,
          cycle_id: Number(price.cycle_id),
          calendar_id: this.calendars.find(
            (calendar) => calendar.name === price.calendar_id
          ).id,
        };
      });

      await httpRda.post("/prices", payload);
      this.$router.go(-1);
    },
  },

  created() {
    this.prices.push(this.price);
    this.getCalendars();
    this.getCycles();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";

.price-card {
  background-color: $grey2;
  border-radius: 12px;
  padding: 32px 24px;
}

#purple-button {
  width: 64px;
  height: 32px;
  background-color: $purple;
  border-color: $purple;
  color: white;
  font-size: 16px;

  &:hover {
    background-color: white;
    border-color: $purple;
    color: $purple;
  }
}

.home {
  height: 100%;
}

.container-rda {
  padding-bottom: 0;
}

label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  color: #495057;
  font-size: 14px;
}
</style>
